import React from "react";
import { useDeviceName } from "../hooks/useDeviceName";
import { Tooltip } from "flowbite-react";

import { DevicePhone } from "./Icons";

interface DeviceLabelProps {
    device: string | null | undefined;
    className?: string;
    showIcon?: boolean;
    iconPosition?: "left" | "right";
}

/**
 * Reusable component to render a human-readable device name.
 * Internally uses the useDeviceName hook.
 */
const DeviceDisplay: React.FC<DeviceLabelProps> = ({
    device,
    className,
    showIcon = false,
    iconPosition = "left"
}) => {
    const resolvedName = useDeviceName(device);

    const renderContent = () => (
        <span className={`flex items-center gap-2 ${className}`}>
            {showIcon && iconPosition === "left" && <div className="w-6 h-4 flex items-center justify-center"><DevicePhone size={16} /></div>}
            {resolvedName || "Unknown Device"}
            {showIcon && iconPosition === "right" && <div className="w-6 h-4 flex items-center justify-center"><DevicePhone size={16} /></div>}
        </span>
    );

    return device ? (
        <Tooltip content={device}>
            {renderContent()}
        </Tooltip>
    ) : renderContent();
};

export default DeviceDisplay;
